
import * as ACTIONS from '../constants';


export function updateLinkedCryodex(payload) {
  return { type: ACTIONS.CRYODEX_CRYODEX_LINKED_UPDATE, payload };
};

export function getLinkedCryodex(payload){
  return { type: ACTIONS.CRYODEX_CRYODEX_LINKED_GET ,payload};
}

export function getCryodexLinks(){
  return { type: ACTIONS.CRYODEX_CRYODEX_LINKS_GET };  
}